import React, { useEffect, useState, useRef } from 'react';
import { SelectNormal, SelectSearch, MultipleSelect } from '../Reusable/SelectBox';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import Swal from 'sweetalert2';
import { BASE_URL } from "../../App";
import { Row, Col, Card } from 'antd';
import DynamicTable from '../Reusable/DynamicTable';
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';

import DriveFolderUploadRoundedIcon from '@mui/icons-material/DriveFolderUploadRounded';
import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, FormGroup, Stack, Backdrop, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, List, ListItem, ListItemText, Checkbox, Grid, FormControlLabel } from '@mui/material';

import CustomTextField from "../Reusable/Numerictext";
import CustomButton from "../Reusable/CustomButton";

export default function PlaceLocator() {
    const [open, setOpen] = React.useState(false);
    const [branchlist, setBranch] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [tableData, setTableData] = useState([]);

    const [isCreateUserPopupOpen, setCreateUserPopupOpen] = useState(false);
    const [isViewPopupOpen, setViewPopupOpen] = useState(false);
    const [editedRowData, setEditedRowData] = useState(null);
    const [editingRow, setEditingRow] = useState(null);
    const [viewData, setViewData] = useState(null);
    const [showData, setShowData] = useState(false);


    const BRANCH_CODE = localStorage.getItem('BRANCH_CODE');
    const token = localStorage.getItem('Token');
    const headers = { Authorization: `Bearer ${token}` };

    useEffect(() => {
        BranchList();
    }, []);

    const BranchList = () => {
        setOpen(true);
        axios.post(BASE_URL + '/branch')

            .then(response => {
                if (response.status === 200) {
                    setBranch(response.data);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: `Error: ${error.response.data.message}`
                    });
                } else if (error.request) {
                    console.error('No response received');
                } else {
                    console.error('Error setting up the request:', error.message);
                }
            }).finally(() => {
                setOpen(false);
            });
    };

    const Branch_List = branchlist ? branchlist.map((type) => ({
        Value: type.CODE,
        Label: type.name,
    })) : [];

    const DealerDetails = () => {
        setOpen(true);

        const data = { type: 'dealer_details', branch_code: selectedBranch };

        axios.post(BASE_URL + '/PlaceLocator', data)
            .then(response => {
                if (response.status === 200) {
                    setTableData(response.data.message);
                    // setOpen(false);
                    setShowData(true);
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    Swal.fire({
                        icon: "warning",
                        text: error.response.data.message,
                    });
                } else if (error.request) {
                    Swal.fire({
                        icon: "warning",
                        text: `No response received`
                    });
                } else {
                    Swal.fire({
                        icon: "warning",
                        text: error.message,
                    });
                }
            }).finally(() => {
                setOpen(false);
            });
    }

    const openCreateUserPopup = (rowData) => {
        setCreateUserPopupOpen(true);
        setEditedRowData(rowData);
    };

    const handleViewEditClick = (rowData) => {
        setViewData(rowData);
        setViewPopupOpen(true);
    };

    const handleReload = () => {
        DealerDetails();
    };

    const handleExportExcelClick = () => {
        if (tableData.length === 0) {
            Swal.fire({
                icon: "info",
                text: 'No Data Available For export!'
            });
            return;
        }
        Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to download the Excel file?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, download it!',
            cancelButtonText: 'No, cancel!',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                setOpen(true);
    
                const ExcelJS = require('exceljs');
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Sheet1');
    
                worksheet.columns = Object.keys(tableData[0]).map(key => ({ header: key, key }));
                tableData.forEach(data => worksheet.addRow(data));
    
                const firstRow = worksheet.getRow(1);
                firstRow.eachCell((cell) => {
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FF0000' }
                    };
                });
    
                setTimeout(() => {
                    workbook.xlsx.writeBuffer().then((buffer) => {
                        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'Place_Locator.xlsx';
                        link.click();
                        setOpen(false);
                    });
                }, 1000);
            }
        });
    };
    
    return (
        <>
            <div className="m-4">
                <Card className="shadow bg-white rounded">
                    <div className='row'>
                        <div className='col-md-6'>
                            <SelectSearch
                                label="Branch Code"
                                required={true}
                                options={Branch_List}
                                value={selectedBranch}
                                onChange={(newValue) => setSelectedBranch(newValue)}
                                size="small"
                            />
                        </div>
                        {showData ? (
                            <>
                                <div className='col-md-4 d-flex align-items-center'>
                                    <Button fullWidth variant="contained" endIcon={<RemoveRedEyeRoundedIcon />} onClick={DealerDetails} ><b>View</b></Button>
                                </div>
                                <div className='col-md-2 d-flex align-items-center'>
                                    <Button fullWidth variant="contained" endIcon={<DriveFolderUploadRoundedIcon />} onClick={handleExportExcelClick}><b>Export Excel</b></Button>
                                </div>
                            </>
                        ) : (
                            <div className='col-md-6 d-flex align-items-center'>
                                <Button fullWidth variant="contained" endIcon={<RemoveRedEyeRoundedIcon />} onClick={DealerDetails} ><b>View</b></Button>
                            </div>
                        )}
                    </div>
                </Card>
            </div>
            <hr />
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
                <CircularProgress color="inherit" />
            </Backdrop>
            {showData && (
                <div className='m-3'>
                    <DynamicTable data={tableData} onEditClick={openCreateUserPopup} onViewClick={handleViewEditClick} className="shadow bg-white rounded" />
                    {isCreateUserPopupOpen && (
                        <EditUserPopup
                            branch={selectedBranch}
                            user={editedRowData}
                            branchlist={branchlist}
                            setTableData={setTableData}
                            onClose={() => {
                                setCreateUserPopupOpen(false);
                                setEditedRowData(null);
                            }}
                            onSave={() => handleReload()}
                        />
                    )}
                    {editingRow && (
                        <EditUserPopup
                            user={editingRow.original}
                            setTableData={setTableData}
                            onClose={() => setEditingRow(null)}
                            onSave={() => handleReload()}
                        />
                    )}
                    {isViewPopupOpen && (
                        <ViewDataPopup
                            data={viewData}
                            onClose={() => setViewPopupOpen(false)}
                        />
                    )}
                </div>
            )}
        </>
    );
}

const EditUserPopup = ({ user, onClose, branchlist, onSave, branch }) => {
    const [errorMsg, setErrorMsg] = useState('');
    const [editedUser, setEditedUser] = useState({ ...user, ACTIVE: '1', });
    const isCreateMode = !user;
    const [open, setOpen] = React.useState(false);

    const login_id = localStorage.getItem("LOGIN_ID");

    const handleCreateSubmit = async () => {
        if (!validateInput()) {
            return;
        }

        const data = {
            type: 'dealer_insert',
            branch_code: branch,
            dealer_name: editedUser.dealername,
            dealer_code: editedUser.dealercode,
            pincode: editedUser.pincode,
            longitude: editedUser.longi,
            latitude: editedUser.lati,
            user_login_id: login_id,
        };

        axios.post(BASE_URL + '/PlaceLocator', data)
            .then(response => {
                if (response.status === 200) {
                    onClose();
                    Swal.fire({
                        icon: "success",
                        text: 'Location Added Successfully.!'
                    }).then(() => {
                        onSave();
                    });
                } else {
                    onClose();
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    onClose();
                    Swal.fire({
                        icon: "warning",
                        text: error.response.data.message,
                    });
                } else if (error.request) {
                    onClose();
                    Swal.fire({
                        icon: "warning",
                        text: `No response received`
                    });
                } else {
                    onClose();
                    Swal.fire({
                        icon: "warning",
                        text: error.message,
                    });
                }
            }).finally(() => {
                setOpen(false);
            });
    };

    const handleSaveSubmit = async () => {

        if (!validateInput()) {
            return;
        }

        const data = {
            type: 'dealer_update',
            dealer_name: editedUser.dealername,
            dealer_code: editedUser.dealercode,
            pincode: editedUser.pincode,
            longitude: editedUser.longi,
            latitude: editedUser.lati,
            user_login_id: login_id,
        };

        axios.post(BASE_URL + '/PlaceLocator', data)
            .then(response => {
                if (response.status === 200) {
                    onClose();
                    Swal.fire({
                        icon: "success",
                        text: 'Location Updated Successfully.!'
                    }).then(() => {
                        onSave();
                    });
                } else {
                    onClose();
                    Swal.fire({
                        icon: "warning",
                        text: 'Unexpected response status. Please try again.'
                    });
                }
            })
            .catch(error => {
                if (error.response) {
                    onClose();
                    Swal.fire({
                        icon: "warning",
                        text: error.response.data.message,
                    });
                } else if (error.request) {
                    onClose();
                    Swal.fire({
                        icon: "warning",
                        text: `No response received`
                    });
                } else {
                    onClose();
                    Swal.fire({
                        icon: "warning",
                        text: error.message,
                    });
                }
            }).finally(() => {
                setOpen(false);
            });
    };

    const Branch_List = branchlist ? branchlist.map((type) => ({
        Value: type.CODE,
        Label: type.name,
    })) : [];

    const validateInput = () => {
        if (!editedUser.dealername || !editedUser.dealercode || !editedUser.pincode || !editedUser.longi || !editedUser.lati) {
            setErrorMsg("Please fill in all fields!");
            return false;
        }
        return true;
    };

    return (
        <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth sx={{ justifyContent: 'center' }}>
            <DialogTitle><u><b>{user ? 'Edit Location' : 'Create New Location'}</b></u></DialogTitle>
            <DialogContent>
                <div className='row'>
                    <div className="col">
                        {isCreateMode ? (
                            <CustomTextField
                                label="Dealer Name"
                                name="dealername"
                                required={true}
                                value={editedUser.dealername}
                                onChange={(e) => setEditedUser({ ...editedUser, dealername: e.target.value })}
                            />
                        ) : (
                            <CustomTextField
                                label="Dealer Name"
                                name="dealername"
                                value={editedUser.dealername}
                                disabled
                                onChange={(e) => setEditedUser({ ...editedUser, dealername: e.target.value })}
                            />
                        )}
                    </div>
                </div>
                <div className='row'>
                    <div className="col">
                        {isCreateMode ? (
                            <CustomTextField
                                label="Dealer Code"
                                name="dealercode"
                                required={true}
                                value={editedUser.dealercode}
                                onChange={(e) => setEditedUser({ ...editedUser, dealercode: e.target.value })}
                            />
                        ) : (
                            <CustomTextField
                                label="Dealer Code"
                                name="dealercode"
                                value={editedUser.dealercode}
                                disabled
                                onChange={(e) => setEditedUser({ ...editedUser, dealercode: e.target.value })}
                            />
                        )}
                    </div>
                    <div className="col">
                        <CustomTextField
                            label="Pincode"
                            name="pincode"
                            required={isCreateMode ? true : false}
                            value={editedUser.pincode}
                            onChange={(e) => setEditedUser({ ...editedUser, pincode: e.target.value })}
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className="col">
                        <CustomTextField
                            label="Longitude"
                            name="longitude"
                            required={isCreateMode ? true : false}
                            value={editedUser.longi}
                            onChange={(e) => setEditedUser({ ...editedUser, longi: e.target.value })}
                        />
                    </div>
                    <div className="col">
                        <CustomTextField
                            label="Latitude"
                            name="latitude"
                            required={isCreateMode ? true : false}
                            value={editedUser.lati}
                            onChange={(e) => setEditedUser({ ...editedUser, lati: e.target.value })}
                        />
                    </div>
                </div>
                {isCreateMode && (
                    <div className="row">
                        <div className='col'>
                            <SelectNormal
                                readOnly={true}
                                label="Branch"
                                name="Branch"
                                options={Branch_List}
                                value={branch}
                                onChange={(e) => setEditedUser({ ...editedUser, BRANCH_CODE: e.target.value })}
                            />
                        </div>
                    </div>
                )}
                {errorMsg &&
                    <div className="row mt-2">
                        <center>
                            <span style={{ color: 'red' }}>* {errorMsg}</span>
                        </center>
                    </div>
                }
                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center' }}>
                <Stack direction="row" spacing={2} sx={{ width: '100%', maxWidth: '400px' }}>
                    <CustomButton
                        label={(isCreateMode ? 'Create' : 'Save')}
                        onClick={isCreateMode ? handleCreateSubmit : handleSaveSubmit}
                        variant="outlined"
                        fullWidth
                        width="200px"
                    />
                    <CustomButton
                        label="Cancel"
                        onClick={onClose}
                        variant="outlined"
                        color="error"
                        fullWidth
                        width="200px"
                    />
                </Stack>
            </DialogActions>
        </Dialog >
    );
};

const ViewDataPopup = ({ data, onClose }) => {
    return (
        <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth sx={{ justifyContent: 'center' }}>
            <DialogTitle><u><b>View Location</b></u></DialogTitle>
            <DialogContent>
                <div className='row'>
                    <div className='col'>
                        <CustomTextField
                            label="Dealer Name"
                            name="dealername"
                            value={data.dealername}
                            InputProps={{ readOnly: true }}
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col'>
                        <CustomTextField
                            label="Dealer Code"
                            name="dealercode"
                            value={data.dealercode}
                            InputProps={{ readOnly: true }}
                        />
                    </div>
                    <div className='col'>
                        <CustomTextField
                            label="Pincode"
                            name="pincode"
                            value={data.pincode}
                            InputProps={{ readOnly: true }}
                        />
                    </div>
                </div>
                <div className='row'>
                    <div className='col'>
                        <CustomTextField
                            label="Longitude"
                            name="longitude"
                            value={data.longi}
                            InputProps={{ readOnly: true }}
                        />
                    </div>
                    <div className='col'>
                        <CustomTextField
                            label="Latitude"
                            name="latitude"
                            value={data.lati}
                            InputProps={{ readOnly: true }}
                        />
                    </div>
                </div>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center' }}>
                <Stack direction="row" spacing={2} sx={{ width: '100%', maxWidth: '400px' }}>
                    <CustomButton
                        label="Close"
                        onClick={onClose}
                        variant="outlined"
                        fullWidth
                        width="400px"
                    />
                </Stack>
            </DialogActions>
        </Dialog >

    );
};